"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DomainRecommendationsModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sharedComponents = require("@site/shared-components");
var _alert = _interopRequireDefault(require("@ux/alert"));
var _box = _interopRequireDefault(require("@ux/box"));
var _button = _interopRequireDefault(require("@ux/button"));
var _card = _interopRequireDefault(require("@ux/card"));
var _chevronLeft = _interopRequireDefault(require("@ux/icon/chevron-left"));
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _space = _interopRequireWildcard(require("@ux/space"));
var _text = _interopRequireDefault(require("@ux/text"));
var _DomainRecommendation = _interopRequireDefault(require("./DomainRecommendation"));
var _ContactSupportMessage = _interopRequireDefault(require("./ContactSupportMessage"));
var _PromptRecommendations = require("../../styles/PromptRecommendations");
var _useFetchPrompts = require("../../hooks/useFetchPrompts");
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DomainRecommendationsSkeleton = ({
  modalPadding
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "domain-ai-suggestions-skeleton",
    className: "prompt-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "main-content-scroll"
  }, /*#__PURE__*/_react.default.createElement(_box.default, {
    orientation: "vertical",
    gap: "md",
    inlinePadding: _space.sizeOptions.LG
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "70%",
    height: "4rem"
  }), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: _space.sizeOptions.XL
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "95%",
    height: "1rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "55%",
    height: "1rem"
  }), Array(6).fill(0).map((_, index) => /*#__PURE__*/_react.default.createElement(_card.default, {
    id: `domainRecommendationLoadingCard-${index}`,
    key: index,
    space: {
      block: _space.sizeOptions.MD,
      inline: _space.sizeOptions.MD
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: "md",
    stretch: true,
    wrap: true,
    orientation: "horizontal",
    blockAlignChildren: "spaceBetween"
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "20%",
    height: "1rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "20%",
    height: "1rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "10%",
    height: "3rem"
  }))))), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: modalPadding
  }, /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: modalPadding
  })))), /*#__PURE__*/_react.default.createElement(_space.default.div, {
    inline: _space.sizeOptions.LG,
    className: "action-container"
  }, /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: modalPadding,
    className: "action-container-inner"
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "40%",
    height: "4rem"
  }))));
};

// TODO: [USIDOM-1465] clean up file to use conversation search - inModal

const DomainRecommendationsModal = ({
  recommendations,
  venture,
  title,
  description,
  onBack,
  onClose,
  onAddToCart,
  isAddingToCart,
  isMobileView,
  getIsDomainPurchased,
  params
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const modalPadding = isMobileView ? _space.sizeOptions.LG : _space.sizeOptions.XL;
  const [recommendationsData, status] = (0, _useFetchPrompts.useMerchRecommendations)({
    ...params,
    disabled: Boolean(recommendations),
    ventureId: venture?.ventureId,
    domain: venture?.domainName,
    vertical: venture?.properties?.vertical || venture?.properties?.businessCategory,
    pageSize: _constants.MAX_RECOMMENDATIONS
  });
  const displayRecommendations = (recommendations || recommendationsData?.recommendations)?.filter(({
    recommendation
  }) => !getIsDomainPurchased(recommendation.domainName));
  const getContent = () => {
    if ((status === _constants.REQUEST_STATUS.INIT || status === _constants.REQUEST_STATUS.LOADING) && !recommendationsData) {
      return /*#__PURE__*/_react.default.createElement(DomainRecommendationsSkeleton, {
        modalPadding: modalPadding
      });
    }
    if (status === _constants.REQUEST_STATUS.FAIL) {
      return /*#__PURE__*/_react.default.createElement(_space.default.div, {
        inline: modalPadding,
        block: modalPadding,
        className: "main-content-scroll"
      }, /*#__PURE__*/_react.default.createElement(_ContactSupportMessage.default, {
        inAlert: true,
        id: "prompt-venture-error",
        alertEmphasis: "critical"
      }), /*#__PURE__*/_react.default.createElement(_space.default.div, {
        block: modalPadding
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: onClose,
        text: formatMessage({
          id: 'searchRecommendation.close'
        }),
        type: "button",
        className: "action-button"
      })));
    }
    if (!displayRecommendations?.length) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_space.default.div, {
        inline: modalPadding,
        block: modalPadding,
        className: "main-content-scroll"
      }, /*#__PURE__*/_react.default.createElement(_alert.default, {
        id: "no-domain-recommendations",
        emphasis: "info",
        "data-testid": "no-domain-recommendations"
      }, formatMessage({
        id: 'searchRecommendation.prompt.noRecommendation'
      }))), /*#__PURE__*/_react.default.createElement(_space.default.div, {
        inline: modalPadding,
        block: modalPadding
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        size: "small",
        disabled: isAddingToCart,
        design: "secondary",
        onClick: onBack,
        className: "action-button",
        text: formatMessage({
          id: 'searchRecommendation.domain.backToSearch'
        }),
        icon: /*#__PURE__*/_react.default.createElement(_chevronLeft.default, null)
      })));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "main-content-scroll"
    }, /*#__PURE__*/_react.default.createElement(_box.default, {
      orientation: "vertical",
      gap: "md",
      inlinePadding: modalPadding
    }, /*#__PURE__*/_react.default.createElement(_text.default.h1, {
      as: "title",
      size: 4,
      text: title
    }), /*#__PURE__*/_react.default.createElement(_text.default.div, {
      text: description
    }), displayRecommendations.slice(0, _constants.MAX_RECOMMENDATIONS).map(({
      recommendation,
      product
    }) => /*#__PURE__*/_react.default.createElement(_card.default, {
      id: `domainRecommendationCard-${recommendation.domainName}`,
      "data-testid": `domain-recommendation-card-${recommendation.domainName}`,
      key: recommendation.domainName,
      className: "recommendation-card",
      space: {
        block: _space.sizeOptions.MD,
        inline: _space.sizeOptions.MD
      }
    }, /*#__PURE__*/_react.default.createElement(_box.default, {
      orientation: "horizontal",
      gap: "md",
      blockAlignChildren: "center",
      inlineAlignChildren: "center"
    }, !isMobileView && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_sparklesFilled.default, {
      className: "sparkle-icon"
    })), /*#__PURE__*/_react.default.createElement(_box.default, {
      stretch: true
    }, /*#__PURE__*/_react.default.createElement(_DomainRecommendation.default, {
      recommendation: recommendation,
      product: product,
      onAddToCart: onAddToCart,
      disabled: isAddingToCart,
      stackDomainAndPrice: isMobileView
    }))))), /*#__PURE__*/_react.default.createElement(_space.default.div, {
      block: modalPadding
    }, /*#__PURE__*/_react.default.createElement(_space.default.div, {
      block: modalPadding
    })))), /*#__PURE__*/_react.default.createElement(_space.default.div, {
      inline: modalPadding,
      className: 'action-container'
    }, /*#__PURE__*/_react.default.createElement(_space.default.div, {
      block: modalPadding,
      className: 'action-container-inner'
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "small",
      disabled: isAddingToCart,
      design: "secondary",
      onClick: onBack,
      text: formatMessage({
        id: 'searchRecommendation.domain.backToSearch'
      }),
      className: "action-button",
      "data-testid": "domain-ai-suggestions-back-button",
      icon: /*#__PURE__*/_react.default.createElement(_chevronLeft.default, null)
    }))));
  };
  return /*#__PURE__*/_react.default.createElement(_PromptRecommendations.StyledDomainsModal, {
    className: "search-recommendations-ai-modal",
    "data-testid": "domain-ai-suggestions-modal",
    onClose: onClose
  }, getContent());
};
exports.DomainRecommendationsModal = DomainRecommendationsModal;
DomainRecommendationsModal.propTypes = {
  recommendations: _propTypes.default.array,
  venture: _propTypes.default.object,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  onBack: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onAddToCart: _propTypes.default.func,
  isAddingToCart: _propTypes.default.bool,
  isMobileView: _propTypes.default.bool,
  getIsDomainPurchased: _propTypes.default.func,
  params: _propTypes.default.object
};
var _default = exports.default = DomainRecommendationsModal;